<script setup lang="ts">
import { ref } from "vue";
import { RouterLink } from "vue-router";
import { storeToRefs } from "pinia";
import {
  HLAvatar,
  HLBreadcrumb,
  HLButton,
  HLIcon,
  HLPopover,
  HLText,
} from "@platform-ui/highrise";
import { useAuthStore } from "@/stores/auth";
import { useTopBarStore } from "@/stores/topBar";
import { ChevronDownIcon } from "@gohighlevel/ghl-icons/24/outline";

const authStore = useAuthStore();
const topBarStore = useTopBarStore();
const { breadcrumbs} = storeToRefs(topBarStore);

const isOpen = ref(false);

const handleLogout = () => {
  authStore.logout();
};

</script>

<template>
  <div class="kaizen-top-bar">
    <div class="top-bar-left">
      <!-- <HLSelect
        id="search-bar"
        @search="setSearchString"
        :options="searchResults"
        :placeholder="searchPlaceholder"
        :filterable="true"
        :show-search-icon="true"
        size="sm"
        @update:value="handleValue"
      /> -->
      <HLBreadcrumb
        v-if="breadcrumbs.length > 0"
        :breadcrumbs="breadcrumbs"
        :home="true"
        @home-click="topBarStore.onBreadcrumbClick({ label: 'Home', href: '/' })"
      />
    </div>
    <slot name="tabs" />
    <div class="top-bar-right">
      <!-- <span class="top-bar-actions"> actions </span> -->
      <HLPopover
        id="user-menu-popover"
        trigger="click"
        @update:show="isOpen = $event"
      >
        <template #trigger>
          <HLButton
            id="user-menu-button"
            variant="text"
            color="gray"
            size="xs"
          >
            <div class="flex items-center gap-2">
              <HLAvatar
                size="xs"
                :name="authStore.user?.name || 'User'"
                color="primary"
              />

              <HLText style="text-transform: capitalize;">
                {{ authStore.user?.name || "User" }}
              </HLText>
              <HLIcon
                size="16"
                :class="{ 'rotate-180': isOpen }"
              >
                <ChevronDownIcon />
              </HLIcon>
            </div>
          </HLButton>
        </template>
        <div class="p-3">
          <div class="user-info">
            <HLAvatar
              size="xs"
              :name="authStore.user?.name || 'User'"
              color="primary"
            />
            <div>
              <HLText style="text-transform: capitalize;">
                {{ authStore.user?.name }}
              </HLText>
              <HLText>
                {{ authStore.user?.email }}
              </HLText>
            </div>
          </div>
          <div class="user-menu-options">
            <RouterLink
              to="/profile"
              class="user-menu-option"
            >
              Profile Settings
            </RouterLink>
            <span
              class="user-menu-option"
              @click="handleLogout"
            >
              Logout
            </span>
          </div>
        </div>
      </HLPopover>
    </div>
  </div>
</template>

<style scoped>

.kaizen-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
}
.kaizen-top-bar .top-bar-right {
  display: flex;
  align-items: center;
}
.top-bar-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
.top-bar-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.top-bar-title {
  font-weight: 600;
}
.user-info {
    align-items: center;
  display: flex;
  gap: 10px;
  padding-bottom: 12px;
}
.user-menu-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.user-menu-options .user-menu-option{
    text-decoration: none;
    color: var(--base-black);
    border-radius: 4px;
    padding: 4px 6px;
    font-size: var(--hr-font-size-sm);
}
.user-menu-options .user-menu-option:hover{
    background-color: var(--primary-50);

}

.kaizen-top-bar{
  background-color: var(--secondary-25);
}
</style>
